import VacLessDay from "./VacLessDay";

export default VacLessDay;